module.exports = __webpack_public_path__ + "img/green_039.036f57a1.png";